import { useState } from 'react';
import { toast } from 'react-toastify';
import fleetApi from '../../services/api.service';

/**
 * Ajustement manuel du stock de palettes consignées d'un destinataire.
 * POST /consignment/adjustments — quantité signée (positive = ajout, négative = retrait).
 *
 * @returns {{ isLoading: boolean, isSuccess: boolean|null, createConsignmentAdjustment: Function }}
 *   createConsignmentAdjustment renvoie l'ajustement créé (avec le stock résultant), ou null en cas d'erreur.
 */
export default function useCreateConsignmentAdjustment() {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);

  const createConsignmentAdjustment = async ({
    addressId,
    packagingId,
    quantity,
    comment,
  }) => {
    setIsSuccess(null);
    try {
      setIsLoading(true);
      const response = await fleetApi.post('/consignment/adjustments', {
        address_id: addressId,
        packaging_id: packagingId,
        quantity,
        comment,
      });

      setIsSuccess(true);
      toast.success('Stock de palettes ajusté avec succès.');
      return response.data?.data ?? null;
    } catch (error) {
      setIsSuccess(false);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          'Une erreur est survenue.'
      );
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, isSuccess, createConsignmentAdjustment };
}
